<header>
    <div class="head-box">
        <i class="fa-solid fa-chevron-left" routerLink="/contents/pages/landing-page"></i>
        <!-- <span class="icon-back" onclick="history.go(-1)"></span> -->
        <div class="head-text">
            <span class="i18n" data-tag="gameReports">{{ 'contents.report.report' | translate }}</span>
        </div>
    </div>
</header>
<main>
    <div class="report">
        <div class="report-top" >
            <select class="ui-select" [(ngModel)]="provider">
                <option value="" class="i18n" data-tag="allGame">
                    {{ 'contents.report.games' | translate }}
                </option>
                <option value="9" class="i18n" data-tag="game.id.9">
                    {{ 'contents.report.provider.bgc' | translate }}
                </option>
                <option value="15" class="i18n" data-tag="game.id.15">
                    {{ 'contents.report.provider.ctc' | translate }}
                </option>
                <option value="17" class="i18n" data-tag="game.id.17">
                    {{ 'contents.report.provider.wic' | translate }}
                </option>
                <option value="18" class="i18n" data-tag="game.id.18">
                    {{ 'contents.report.provider.gmpgs' | translate }}
                </option>
                <option value="19" class="i18n" data-tag="game.id.19">
                    {{ 'contents.report.provider.gmpps' | translate }}
                </option>
                <option value="23" class="i18n" data-tag="game.id.23">
                    {{ 'contents.report.provider.dgc' | translate }}
                </option>
            </select>
            <dl class="time-menu">
                <dd class="tableId i18n" [class.active]="activeTab === 'tDay'" data-tag="tDay" (click)="setToday()">{{
                    'contents.report.tday' | translate }}</dd>
                <dd class="tableId i18n" [class.active]="activeTab === 'yDay'" data-tag="yDay" (click)="setYesterday()">
                    {{ 'contents.report.yday' | translate }}</dd>
                <dd class="tableId i18n" [class.active]="activeTab === 'tWeek'" data-tag="tWeek"
                    (click)="setLast7Days()">{{ 'contents.report.7day' | translate }}</dd>
            </dl>
        </div>

        <div class="report-top">
            <select class="beginTime" [(ngModel)]="startDate">
                <ng-container *ngIf="dateList">
                    <ng-container *ngFor="let date of dateList">
                        <option value="{{date}}">{{ date }}</option>
                    </ng-container>
                </ng-container>
            </select>
            <select class="endTime" [(ngModel)]="endDate">
                <ng-container *ngIf="dateList">
                    <ng-container *ngFor="let date of dateList">
                        <option value="{{date}}">{{ date }}</option>
                    </ng-container>
                </ng-container>
            </select>
            <button class="i18n search-btn" data-tag="search" (click)="onSearch()">{{ 'contents.report.search' |
                translate }}</button>
        </div>

        <div class="report-mid">
            <table>
                <thead>
                    <tr>
                        <th class="i18n" data-tag="game">{{ 'contents.report.game' | translate }}</th>
                        <th class="i18n" data-tag="betTime">{{ 'contents.report.bet_time' | translate }}</th>
                        <th class="i18n" data-tag="gameBetAmount">{{ 'contents.report.bet_amount' | translate }}</th>
                        <th class="i18n" data-tag="winLoss">{{ 'contents.report.winloss' | translate }}</th>
                        <th class="i18n" data-tag="isRevocation">{{ 'contents.report.payroll_status' | translate }}</th>
                    </tr>
                </thead>
                <tbody id="tbody">
                    <ng-container *ngIf="this.report && this.report.Records">
                        <ng-container *ngFor="let record of this.report.Records; let i = index">
                            <tr>
                                <th>{{ record.ProviderName }} {{ record.GameName }}</th>
                                <th>{{ record.SettlementTime | date: 'yyyy-MM-dd HH:mm:ss' }}</th>
                                <th>{{ record.BetAmt.toFixed(2) }}</th>
                                <th [style.color]="record.WlAmt >= 0 ? 'green' : 'red'">{{ record.WlAmt.toFixed(2) }}
                                </th>
                                <th>{{ record.TicketStatus }}</th>
                            </tr>
                        </ng-container>
                    </ng-container>

                </tbody>
                <tfoot id="tfoot">
                    <tr>
                        <th class="i18n" data-tag="total">{{ 'contents.report.total' | translate }}</th>
                        <th class=""></th>
                        <th class="bet-points">{{ this.totalBetAmt.toFixed(2) }}</th>
                        <th class="total-win">{{ this.totalWlAmt.toFixed(2) }}</th>
                        <th></th>
                    </tr>
                </tfoot>
            </table>
        </div>
        <input type="hidden" id="tableId">
        <div class="report-bom">
            <div class="pagination">
                <a class="prev pre_page" href="javascript:void (0)" (click)="filp(-1)">‹</a>
                <div class="page">
                    <span id="pageNow">{{ report?.Pagination?.PageNumber || 1 }}</span>
                    /
                    <span id="pageCount">{{ (report?.Pagination && report?.Pagination?.TotalPages ) ?
                        report?.Pagination?.TotalPages : 0 }}</span>
                </div>
                <a class="next next_page" href="javascript:void (0)" (click)="filp(1)">›</a>
                <input #pageInput placeholder="{{ 'contents.report.page' | translate }}" id="goPage" class="i18n">
                <a class="next goPage" href="javascript:void(0)" (click)="skip(pageInput.value)">{{ 'contents.report.go'
                    | translate }}</a>
            </div>
        </div>
    </div>
</main>